import "./cardCurso.css";
import React from "react";
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { red } from '@mui/material/colors';
import favorito from "../../../media/icons/item_star_icon_stroke.svg"

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const CardCurso = props => {
    return (

        <Card sx={{ flexBasis: 300, background: "#191922", borderRadius: "15px", boxShadow: "0 0 3px black", color: "white" }} className="cardCourse" >
            <div className="CardHeader">
                <div className="containerLeft">
                    <img src={require("../../../media/course_partners/" + props.partnerLogo)} height={60} />

                    <div className="titleSubtitleCard">
                        <h1>{props.nomeCurso}</h1>
                        <span>{props.partnerName}</span>
                    </div>
                </div>
                <div className="iconCategoryCard">
                    {props.categoriaIco}
                </div>
            </div>
            <CardMedia
                sx={{width: "300px", height: "180px", objectFit: "cover"}}
                component="img"
                image={require("../../../media/course_banners/" + props.banneCurso)}
            />
            <CardContent sx={{ width: "100%" }}>
                <div className="listCourseDetails">
                    <ul>
                        <li>Duração: <strong>{props.duracao}</strong></li>
                        <li>Localidade: <strong>{props.localidade}</strong></li>
                        <li>{props.conteudos}</li>
                    </ul>
                </div>

            </CardContent>

            <CardActions disableSpacing className="cardActions">
                <button aria-label="add to favorites">
                    <img src={favorito} height="20px" color="white" />
                </button>
                <button aria-label="share">
                    RECOMENDAR
                </button>
            </CardActions>
        </Card>

    );
}

export default CardCurso;





/*

CARD ANTIGO



  <div className="cardCurso">
            <div className="containerRosa" ></div>
            <div className="containerCardCurso">

                <div className="cadCursoHeader">
                    <h3 className="cardTamanho1">Metodologia ágeis</h3>
                    <h4 className="cardTamanho2">Intituto Proa - Administração</h4>
                    <span className="stars">
                        <i class="bi bi-star"></i>
                        <i class="bi bi-star"></i>
                        <i class="bi bi-star"></i>
                        <i class="bi bi-star"></i>
                        <i class="bi bi-star"></i>
                    </span>
                    <div className="separador"></div>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In rerum,
                        nesciunt repudiandae perferendis aut consectetur facere. Eius obcaecati
                        vero maiores quisquam, assumenda ex fugiat consequatur quod delectus odio
                        sunt officiis.</p>
                </div>
                <div className="interacaoCurso">
                    <span className="informacaoDuracao">
                        <i className="bi bi-clock-history"></i>
                        <div>
                            <h2 className="cardTamanho1">Duração</h2>
                            <h3 className="cardTamanho2">120h</h3>
                        </div>
                    </span>
                    <i className="bi bi-clipboard2-check"></i>
                    <i className="bi bi-star"></i>
                </div>
                <div className="InteracaoRecomendarMais">
                    <button className="buttonRecomendarMais">Recomendar</button>
                    <button className="buttonRecomendarMais buttonMais">. . .</button>
                </div>
            </div>

        </div>
*/